module.exports = __webpack_public_path__ + "static/media/road-america-2024.8c900699.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/road-america-2024.png
// module id = 1146
// module chunks = 0